import { render } from "./dialogWin.vue?vue&type=template&id=82e12986&scoped=true"
import script from "./dialogWin.vue?vue&type=script&lang=js"
export * from "./dialogWin.vue?vue&type=script&lang=js"

import "./dialogWin.vue?vue&type=style&index=0&id=82e12986&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82e12986"]])

export default __exports__